/* globals window, BOOMR */
/*eslint-disable no-console*/

'use strict';

const logError = require('./log_error');
/*
  Asynchronously Fetch Javascript

  @param {Array} [modulePromises] - an array of js files fetched by the webpack import() function
  @param {Integer} [timeOut] - how long to wait until sending a timeout error
  @param {Function} [callback] - what to do when all modules are loaded
*/

const asyncInitializer = (modulePromises, timeOut, callback) => {
  const safeInit = (obj, cb) => {
    try {
      obj.init(window.payload, cb);
    } catch (error) {
      logError(error, 'DealPage-AsyncFrontEndInit-Error');
      cb();
    }
  };

  let loadedModules = 0;
  let initModules = 0;
  const initStart = new Date();

  if (modulePromises.length) {
    window.payload.componentData = {};
  }

  modulePromises.forEach(modulePromise => {
    modulePromise
      .then(module => {
        loadedModules += 1;
        safeInit(module, () => {
          initModules += 1;
          if (
            initModules === modulePromises.length &&
            typeof BOOMR !== 'undefined' &&
            typeof BOOMR.addVar === 'function'
          ) {
            BOOMR.addVar(
              'deal_page_async_modules_initialized',
              new Date() - initStart
            );
          }
        });
        if (loadedModules === modulePromises.length) {
          callback(initStart);
        }
      })
      .catch(error => {
        logError(error, 'DealPage-AsyncFrontModulePromise-Error');
      });
  });

  setTimeout(() => {
    if (loadedModules !== modulePromises.length) {
      logError(
        new Error(
          `${modulePromises.length - loadedModules} modules failed to load`
        ),
        'DealPage-AsyncFrontModules-Timeout',
        'Frontend Async Module Initialization timed out'
      );
      callback(initStart);
    }
  }, timeOut);
};

window.asyncInitializer = asyncInitializer;
module.exports = asyncInitializer;
